import { jsx, jsxs } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import { BaseCell } from '../BaseCell/index.js';
import { Heading as StyledHeading } from '../Heading/index.js';
import { IconButtonClose } from '../IconButtonClose/index.js';
import { CellContent } from './styles.js';

const CellModalHeader = ({
  headingText,
  closeButtonOnClick,
  ...props
}) => {
  const headingRef = useRef(null);
  useEffect(() => {
    if (headingRef.current) {
      headingRef.current.focus();
    }
  }, []);
  return jsx(BaseCell, Object.assign({
    divider: "bottom"
  }, props, {
    children: jsxs(CellContent, {
      children: [jsx(StyledHeading, Object.assign({
        elementRef: headingRef,
        tabIndex: -1
      }, {
        children: headingText
      }), void 0), jsx(IconButtonClose, {
        iconSize: "sm",
        onClick: closeButtonOnClick
      }, void 0)]
    }, void 0)
  }), void 0);
};
CellModalHeader.displayName = 'CellModalHeader';

export { CellModalHeader };
